import fetch from '@/services/fetch'
import * as api from '@/config/api'

export const getAccessToken = function(context, credentials) {
  return new Promise((resolve, reject) => {
    fetch
      .post(api.login, {
        grant_type: process.env.VUE_APP_GRANT_TYPE,
        client_id: process.env.VUE_APP_CLIENT_ID,
        client_secret: process.env.VUE_APP_CLIENT_SECRET,
        username: credentials.username,
        password: credentials.password
      })
      .then(response => {
        const token = response.data.access_token
        localStorage.setItem('access_token', token)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getUserInfo = function(context) {
  return new Promise((resolve, reject) => {
    fetch
      .get(api.userInfo, {})
      .then(response => {
        const user = response.data
        context.commit('SET_USER', user)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const removeAccessToken = function() {
  return new Promise((resolve, reject) => {
    fetch
      .post(api.logout, {})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        // console.log('Logout Error', error)
        reject(error)
      })
      .finally(() => {
        localStorage.removeItem('access_token')
      })
  })
}
